const FakeBineos = new Proxy(() => {
}, {
  construct(target, constructorArguments) {
    console.info('construct', constructorArguments);

    return new Proxy({}, {
      get(_, property, receiver) {
        return (...args) => {
          console.info('get', property, args);
          return receiver;
        };
      },
    });
  },
});

class BineosTracker {
  constructor({
    container,
    domain,
    touchpoint,
    taxonomy,
    ivw,
    document,
    dataLayer,
    bineos: Bineos,
  }) {
    if (Bineos) {
      this.instance = new Bineos(container, domain);
    } else {
      this.instance = new FakeBineos(container, domain);
    }

    this.touchpoint = touchpoint;
    this.taxonomy = taxonomy;
    this.ivw = ivw;
    this.document = document;

    this.user = dataLayer.filter((item) => Object.prototype.hasOwnProperty.call(item, 'username')).length > 0;
  }

  data() {
    let data;
    if (this.touchpoint === 'article') {
      data = {
        ...this.findArticle(),
      };
    } else {
      data = {
        customTopicId: this.taxonomy,
        ivwId: this.ivw,
      };
    }

    return {
      touchpoint: this.touchpoint,
      userStatus: this.user ? 'eingeloggt' : 'nicht eingeloggt',
      ...data,
    };
  }

  track() {
    try {
      this.instance.set(this.data()).send();
    } catch (e) {
      console.error(e);
    }
    return this.instance;
  }

  findArticle() {
    const article = this.document.querySelector('[data-article-id]');
    if (!article || !article.dataset.articleId) {
      throw Error('Article not found.');
    }

    return {
      articleId: article.dataset.articleId,
      ivwId: article.dataset.ivwId ? article.dataset.ivwId : null,
      customTopicId: article.dataset.customTopicId ? article.dataset.customTopicId : null,
      form: article.dataset.bineosForm ? article.dataset.bineosForm : null,
      thema: article.dataset.bineosThema ? article.dataset.bineosThema : null,
    };
  }
}

export default BineosTracker;
